import React, { HTMLAttributes } from "react";

export const Indicator: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => (
  <>
    <div
      className="indicator absolute flex items-center justify-center leading-none opacity-100 pointer-events-none rounded-full text-white text-xs bg-notification"
      {...props}
    >
      {children}
    </div>
    <style jsx>
      {`
        .indicator {
          min-height: 20px;
          min-width: 20px;
          top: -8px;
          right: -8px;
          transition: opacity 250ms linear;
        }

        .indicator--bag {
          right: -12px;
        }

        .indicator:empty {
          opacity: 0;
        }
      `}
    </style>
  </>
);
